// src/components/button/BtnEditPanel.tsx

import { EditTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

type BtnEditPanelProps = {
  disabled?: boolean
  onClick: () => void
}

export const BtnEditPanel = ({
  disabled = false,
  onClick,
}: BtnEditPanelProps) => (
  <Tooltip title={'Einstellungen'}>
    <IconButton disabled={disabled} onClick={onClick}>
      <EditTwoTone />
    </IconButton>
  </Tooltip>
)
